import { Column } from '@ant-design/charts'

import { useChartTheme } from '@/components/charts/chartTheme'

import type { ChargeWindow } from '../useBusinessQueries'
import { periodKey, periodLabel } from './chargePeriods'
import type { ChargePoint } from './chargeSummary'

export function ChargesChart({
  points,
  window,
  range,
  share,
}: {
  points: ChargePoint[]
  window: ChargeWindow
  range: { from: string; to: string }
  share: boolean
}) {
  const chart = useChartTheme()
  const data = points.map((point) => ({
    ...point,
    period: periodLabel(periodKey(point.period, window), window, range),
  }))
  return (
    <Column
      data={data}
      xField="period"
      yField="value"
      colorField="category"
      stack
      percent={share}
      height={300}
      axis={{
        x: { ...chart.axis.x, labelAutoHide: true },
        y: {
          ...chart.axis.y,
          labelFormatter: (v: number) =>
            share ? `${Math.round(v * 100)}%` : `$${v}`,
        },
      }}
      legend={chart.legend}
      tooltip={{
        items: [{ field: 'value', valueFormatter: (v: number) => `$${v}` }],
      }}
      style={{ maxWidth: 24 }}
    />
  )
}
